import React from 'react'
import { connect } from 'react-redux'
import { logRender } from '../../utils/logging'
import { withTranslation } from 'react-i18next'
import { deepEqualObjs2 } from '../../utils/objtools'
import { mapResourceFromCode } from '../resource/resource_selectors'
import Button from 'react-bootstrap/Button'
import {submitApplicationFinalFormDeleteHandler} from './application_routines'
import { modalAdd } from '../modals/modals_actions'
import {bindPromiseCreators} from "redux-saga-routines";
import ApplicationDeleteFinalForm from "./ApplicationDeleteFinalForm";

class ApplicationDelete extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !deepEqualObjs2(this.props.redux, nextProps.redux)
      || this.props.tReady !== nextProps.tReady
    )
  }

  render() {
    logRender(this)
    if (!this.props.tReady)
      return null

    return (
      <div className={this.getItemClasses().join(' ')} >
        <div className="grid g1_root g1_1col">
          <h2>{this.props.t('application:tab_delete_title')}</h2>
          <p className="chapeau">{this.props.t('application:delete_chapeau')}</p>
          <Button variant="danger" onClick={()=>this.deleteClick()} disabled={!this.props.redux.application.loaded}>{this.props.t('application:delete_button')}</Button>
         </div>
      </div>
    )
  }

  getItemClasses() {
    var classes = [
      'application',
      'delete'
    ]
    return classes
  }

  deleteClick() {
    this.props.modalAdd(
      'form',
      {
        title: this.props.t('application:delete_modal_title'),
        message: this.props.t('application:delete_modal_message'),
        FormComponent: ApplicationDeleteFinalForm,
        formComponentProps: {
          form_op: "new",
          initialValues: {
            ids: this.props.redux.application.ids
          }
        },
        submitAction: this.props.submitApplicationFinalFormDeleteHandler,
        closeAction: false
      }
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  var redux = {
    application: mapResourceFromCode(state, 'application', ownProps.resourceCode),
    lang_code: state.lang.lang_code,
  }
  return {
    redux
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindPromiseCreators({
      submitApplicationFinalFormDeleteHandler
  }, dispatch),
  modalAdd: (modalType, modalProps) => dispatch(modalAdd(modalType, modalProps))
})

ApplicationDelete = withTranslation(['common','application'])(ApplicationDelete)

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationDelete)
